import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appPreventLongOrders]',
  standalone: true,
})
export class PreventLongOrdersDirective {
  @Output() invalidOrderLength = new EventEmitter<string>();

  private maxLength = 4;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const allowedKeys = [
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
      'Tab',
    ];
    if (allowedKeys.includes(event.key)) {
      return;
    }
    if (input.value.length >= this.maxLength) {
      event.preventDefault();
      this.invalidOrderLength.emit(
        `El orden no puede superar los ${this.maxLength} dígitos`,
      );
    }
  }
}
